import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Image, Row } from "react-bootstrap";
import { ITeacher, SubjectKind } from "common/types";
import Spinner from "../../spinner";
import api from "common/api";
import usePageTitle from "common/usePageTitle";
import { s3_url } from "common/constants";

interface TeacherPageProps {
  kind?: SubjectKind;
}

function TeacherPage({ kind }: TeacherPageProps) {
  const [teachers, setTeachers] = useState<ITeacher[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const PREPARATION_STATIC_TEACHERS: any[] = [
    {
      user_id: -1,
      first_name: "Karmen",
      last_name: "Dasović",
      profile: {
        title: "mag.educ.",
        picture:
          "https://awesome-lumen-web-2-31.s3.amazonaws.com/teachers/Karmen.webp",
        remark:
          "Karmen je magistra edukacije matematike i fizike, diplomu je stekla na Pedagoškom fakultetu u Rijeci. Svoju ljubav prema matematici i fizici pokazuje svakodnevno pomažući učenicima u savladavanju nastavnih sadržaja u školi za poduke Lumen, čija je i vlasnica. Karmen je veoma strpljiva i smirena i uvijek nasmijana te je uz njezinu podršku učenje nastavnih sadržaja zaista lako. Za vas je osmislila i nešto novo, platformu za učenje Lumen@home.",
      },
    },
    {
      user_id: -2,
      first_name: "Mia",
      last_name: "Černivec",
      profile: {
        title: "mag.educ.",
        picture:
          "https://awesome-lumen-web-2-31.s3.amazonaws.com/teachers/Mia.webp",
        remark:
          "Mia je magistra edukacije matematike i informatike. Diplomirala je na Odjelu za matematiku, Sveučilišta u Rijeci, a trenutno radi kao profesorica u Medicinskoj školi u Rijeci. Matematika je njezina ljubav i uvijek će se potruditi nastavne sadržaje objasniti vam na zanimljiv način koji će vam ostati dugooo u pamćenju. Uspješno je pripremila mnoge generacije za ispit državne mature iz matematike i iz te se učionice Lumenom uvijek ori smijeh.",
      },
    },
    {
      user_id: -3,
      first_name: "Maria",
      last_name: "Juretić Mohorić",
      profile: {
        title: "dipl. biokemičarka",
        picture:
          "https://awesome-lumen-web-2-31.s3.amazonaws.com/teachers/Maria.webp",
        remark:
          "Maria je nastavnica kemije u Medicinskoj školi u Rijeci, a svoju diplomu diplomirane biokemičarke stekla je na Sveučilištu u Ljubljani. Njezina su predavanja jednostavna, pregledna i posložena kako bi riješila sve vaše nedoumice za nastavne sadržaje kemije. Plus je što je Maria uvijek nasmijana i najteži kemijski problem uz njezina predavanja postat će jednostavan i jasan.",
      },
    },
    {
      user_id: -4,
      first_name: "Eliza",
      last_name: "Fućak",
      profile: {
        title: "univ.mag.",
        picture:
          "https://awesome-lumen-web-2-31.s3.amazonaws.com/img/nastavnici/Eliza.webp",
        remark:
          "Eliza je molekularni biolog, a svoju diplomu stekla je na zagrebačkom PMF-u. Biologiju je odabrala jer voli promatrati i razumjeti svijet oko sebe te učiti o njemu. Lako će vas zainteresirati za prirodni svijet koji je pun nevjerojatnih bića i priča čiji su oni glavni likovi. Na pripremama očekujte zanimljivu, radnu i veselu atmosferu.",
      },
    },
    {
      user_id: -5,
      first_name: "Ana",
      last_name: "Kramarić",
      profile: {
        title: "mag.educ.",
        picture:
          "https://awesome-lumen-web-2-31.s3.amazonaws.com/img/nastavnici/Ana.webp",
        remark:
          "Naša Ana profesorica je hrvatskog i njemačkog jezika i književnosti. Diplomirala je na Filozofskom fakultetu u Rijeci. Iskustvo u poučavanju stekla je radeći kao učiteljica hrvatske nastave u inozemstvu te kao predavačica njemačkog jezika i hrvatskog jezika kao stranog jezika u školama stranih jezika. Ana ima mnoštvo zanimljivih hobija i na njezinim podukama sigurno vam neće biti dosadno.",
      },
    },
    {
      user_id: -6,
      first_name: "Igor",
      last_name: "Lisac",
      profile: {
        title: "mag.phys.",
        picture:
          "https://awesome-lumen-web-2-31.s3.amazonaws.com/img/nastavnici/Igor.webp",
        remark:
          "Igor je profesor fizike poznat po tome što složene pojave objašnjava na jednostavan i zanimljiv način, povezujući teoriju sa svakodnevnim životom. Njegova predavanja potiču učenike na razmišljanje, istraživanje i postavljanje pitanja, čime razvija znatiželju i kritičko mišljenje.",
      },
    },
  ];

  usePageTitle("Nastavnici");

  useEffect(() => {
    const fetchTeachers = async () => {
      setLoading(true);
      try {
        const response = await api.get("/teachers/");
        let filteredTeachers = response.data;

        if (kind === SubjectKind.LESSON) {
          filteredTeachers = response.data.filter(
            (teacher: any) =>
              teacher.lesson_profile?.subjects &&
              teacher.lesson_profile.subjects.length > 0,
          );
        } else if (kind) {
          filteredTeachers = response.data.filter(
            (teacher: any) => teacher.profile != null,
          );
        }

        setTeachers(filteredTeachers);
      } catch (error) {
        console.log("error");
      } finally {
        setLoading(false);
      }
    };

    fetchTeachers();
  }, [kind]);

  return (
    <Row>
      <h1>Nastavnici</h1>
      <hr />
      {loading ? (
        <Spinner />
      ) : (
        <Container>
          {kind === SubjectKind.LESSON && (
            <Row>
              {teachers.map((teacher) => {
                const profileData = teacher.lesson_profile;

                if (profileData?.hidden) {
                  return;
                }

                return (
                  <Col
                    key={teacher.user_id}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    className="mb-4"
                  >
                    <div className="text-center mb-2">
                      <Image
                        src={
                          profileData?.picture ||
                          `${s3_url}/img/lumenko/lumenko.webp`
                        }
                        alt={teacher.first_name}
                        style={{
                          width: "120px",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                        loading="lazy"
                      />
                    </div>
                    <div className="text-center">
                      <h3>{teacher.first_name}</h3>
                      {profileData?.subjects &&
                        profileData.subjects.length > 0 && (
                          <div className="mt-2">
                            {profileData.subjects.map(
                              (subject: any, index: number) => (
                                <Badge
                                  key={index}
                                  bg="primary"
                                  className="me-1 mb-1"
                                >
                                  {subject.name}
                                </Badge>
                              ),
                            )}
                          </div>
                        )}
                      <p>{profileData?.remark}</p>
                    </div>
                  </Col>
                );
              })}
            </Row>
          )}

          {kind === SubjectKind.PREPARATION && (
            <>
              {PREPARATION_STATIC_TEACHERS.map((teacher) => {
                const profileData = teacher.profile;
                return (
                  <Row key={teacher.user_id} className="mb-3">
                    <Col xs="auto">
                      <Image
                        src={
                          profileData?.picture ||
                          `${s3_url}/img/lumenko/lumenko.webp`
                        }
                        alt={teacher.first_name}
                        style={{
                          width: "250px",
                          height: "auto",
                          borderRadius: "10px",
                        }}
                        loading="lazy"
                      />
                    </Col>
                    <Col className="pt-3 px-4">
                      <h2>
                        {teacher.first_name} {teacher.last_name}
                        {profileData?.title ? `, ${profileData.title}` : ""}
                      </h2>
                      <p>{profileData?.remark}</p>
                    </Col>
                  </Row>
                );
              })}
            </>
          )}
        </Container>
      )}
    </Row>
  );
}

export default TeacherPage;
